import { Stack } from '@mui/material';

import { Tag } from './tag';

export const Tags = ({ tags }: { tags: Record<string, string> }) => {
  return (
    Object.entries(tags).length && (
      <Stack gap='8px' direction='row' flexWrap='wrap'>
        {Object.entries(tags).map((entry) => (
          <Tag
            variant='outlined'
            key={entry[0]}
            content={entry.filter((x) => x).join('=')}
          />
        ))}
      </Stack>
    )
  );
};
